import React from "react";

const FAQ = () => {
  return (
    <div className="text-center">
      <h1>FAQs</h1>
      <h3>Page coming soon</h3>
    </div>
  );
};

export default FAQ;
